import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractContractGenerationService } from 'src/app/shared/services/contract-generation/abstract-contract-generation.service';
import { CustomerService } from '../../customers/crud-service';
import {
    IContractablePlan,
    IContractableEntityService,
    IRelatedPersons
} from 'src/app/domain/registration/interfaces/contract-generation.interfaces';

/**
 * Serviço específico para geração de contratos de clientes
 * Implementa a lógica específica de clientes estendendo o serviço abstrato
 */
@Injectable({
    providedIn: 'root'
})
export class CustomerContractGenerationService
    extends AbstractContractGenerationService
    implements IContractableEntityService {

    constructor(private customerService: CustomerService) {
        super();
    }

    /**
     * Obtém um cliente por ID
     */
    get(id: string): Observable<any> {
        return this.customerService.get(id);
    }

    /**
     * Obtém planos do cliente
     */
    getPlans(customerId: string): Observable<IContractablePlan[]> {
        return this.customerService.get(customerId).pipe(
            map((customer: any) => {
                if (!customer.customerPlans) {
                    return [];
                }

                return this.filterActivePlans(customer.customerPlans);
            })
        );
    }

    /**
     * Obtém pessoas relacionadas ao cliente
     */
    getRelatedPersons(customerId: string): Observable<IRelatedPersons> {
        return this.customerService.get(customerId).pipe(
            map((customer: any) => ({
                partner: customer.partner || null,
                consultant: customer.consultant || null,
                representative: customer.representative || null,
                counter: customer.counter || null,
                unit: customer.unit || null,
                partnerId: customer.partnerId || null,
                consultantId: customer.consultantId || null,
                representativeId: customer.representativeId || null,
                counterId: customer.counterId || null,
                unitId: customer.unitId || null
            }))
        );
    }

    /**
     * Implementação específica para obter nome de entidade do cliente
     */
    protected getEntityName(entity: any): string {
        return entity.name || entity.companyName || entity.tradingName || 'Cliente';
    }

    /**
     * Método auxiliar para obter IDs de pessoas relacionadas
     */
    getRelatedPersonIds(relatedPersons: IRelatedPersons): {
        partnerId?: string;
        consultantId?: string;
        representativeId?: string;
        counterId?: string;
        unitId?: string;
    } {
        return {
            partnerId: relatedPersons['partnerId'] || relatedPersons.partner?.id,
            consultantId: relatedPersons['consultantId'] || relatedPersons.consultant?.id,
            representativeId: relatedPersons['representativeId'] || relatedPersons.representative?.id,
            counterId: relatedPersons['counterId'] || relatedPersons.counter?.id,
            unitId: relatedPersons['unitId'] || relatedPersons.unit?.id
        };
    }
}


